import React, { useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import { AddIcon, BackArrowIcon, DeleteIcon, EditIcon, PlanIcon, RightArrowIcon } from "../../Assets/Icons";
import { useNavigate, useParams } from "react-router-dom";
import ParentGroup from "../../components/ParentGroup";
import PlansList from "../../components/Management/PlansList";
import PlanFunctionButton from "../../components/Management/PlanFunctionButton";

const { BackButton, SimInputBar, DropdownSearch } = UiComponents;

const ManageSubscription = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;
  const backClick = () => navigate(-1);

  
  return (
    <>
    <div className="org-plans">
      <div className="page-title" style={{ border: "none" }}>
        <div className="title-back">
          <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
          <h6> Manage Plan And Subscription </h6>
        </div>
      </div>

      <div className="plans-info">
        <div className="org-detail">
          <ParentGroup uuid={id} />
        </div>

        <div className="plans-details">
          <div className="plan-list">
            <PlansList uuid={id} />
          </div>

          <div className="plan-function">
            <PlanFunctionButton uuid={id} />
          </div>

        </div>
      </div>
      
    </div>
    </>
  );
};

export default ManageSubscription;
